<template>
  <a-card :normalize-card-body="normalizeCardBody">
    <div slot="header" class="d-flex justify-content-between w-100">
      <span v-t="title" />
      <span
        v-if="count !== undefined"
        class="badge badge-info me-0"
        v-text="count"
      />
    </div>
    <slot slot="body" />
    <slot v-if="hasActionsSlot" slot="footer" name="actions" />
  </a-card>
</template>

<script>
import Card from "+/components/card/Card";
export default {
  components: {
    "a-card": Card
  },
  props: {
    title: { type: String, default: "title" },
    count: { type: [String, Number], default: undefined },
    normalizeCardBody: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasActionsSlot() {
      return !!this.$slots.actions;
    }
  }
};
</script>
